import { createAction, props } from '@ngrx/store';
import { ITable } from '@common/models/table';
import { EntityKey } from '@feature/pma-document-centre/pma-document-centre-types';

const source = '[PMA Document Centre Widget]';
const name = (actionName: string) => `${source} ${actionName}`;



export const apiLoad = createAction(
  name('API Load'),
  props < {
    widgetId: number;
    dashboardIdentifier: string;
    limit: number;
    entityKey: EntityKey;
    external: boolean;
    includeParents: boolean;
    includeChildren: boolean;
  }>()
);

export const apiLoadComplete = createAction(
  name('API Load Complete'),
  props<{ widgetId: number; data: ITable }>()
);
